import { forwardRef } from "react";
const SvgPriorityUp = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path transform="rotate(90) translate(0 -15)" d="M7 4L3 8L7 12M13 4L9 8L13 12" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /></svg>;
const ForwardRef = forwardRef(SvgPriorityUp);
export default ForwardRef;